import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Order } from '../../interfaces/orders/order';
import { ConfigurationState } from '../../services/configuration-state/configuration-state';
import { IdentityVerificationDetails } from '../../interfaces/identity-verification-details/identity-verification-details';
import { KnowYourCustomerResultsRepositoryService } from '../../services/know-your-customer-results/know-your-customer-results-repository.service';
import { eOrderStatusType, eOrderType } from '../../enums';

@Component({
  selector: 'lib-know-your-customer-details',
  templateUrl: './know-your-customer-details.component.html',
  styleUrl: './know-your-customer-details.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class KnowYourCustomerDetailsComponent implements OnInit {
  @Input() order!: Order;
  protected isSubmitted: boolean = false;
  protected shouldShowPepsAndSanctions: boolean = false;
  protected fintracCompliant: boolean = false;
  protected fintracMethod: string | null | undefined = null;
  protected showCompliance: boolean = false;

  constructor(private configurationState: ConfigurationState,
    private knowYourCustomerResultsService: KnowYourCustomerResultsRepositoryService
  ) { }

  ngOnInit(): void {
    this.isSubmitted = this.order.orderStatusTypeID !== eOrderStatusType.draft;
    this.configurationState.canSubmitOrderType(eOrderType.pepsAndSanctions).then(val => this.shouldShowPepsAndSanctions = val);

    this.showCompliance = this.isSubmitted && this.order.orderStatusTypeID === eOrderStatusType.complete;

    if (this.showCompliance) {
      this.knowYourCustomerResultsService.getKnowYourCustomerResults(this.order.id).subscribe(results => {
        this.fintracCompliant = results.fintracResults.isFintracPassed;
        this.fintracMethod = results.fintracResults.fintracMethod;
      });
    }
  }
}